export default "__VITE_ASSET__c7143ea4__"